import { Component } from '@angular/core';
import { TableColumnToggleBaseRenderer } from '../base/toggle-base-renderer';
@Component({
  selector: 'table-column-slide-toggle-renderer',
  templateUrl: './slide-toggle-renderer.component.tpl.html'
})
export class TableColumnSlideToggleRendererComponent extends TableColumnToggleBaseRenderer {
}
